<template>
  <div class="container">
    <div class="dashboard-grid">
      <OutstandingActions v-bind="components.OutstandingActions" />
      <StartNewProjects v-bind="components.StartNewProjects" />
      <ChartBlocks :config="chartBlocks" :enable-chart-presets="enableChartPresets" />
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

import ChartBlocks from '@projects/components/ChartBlocks.vue'
import OutstandingActions from '@projects/components/OutstandingActions.vue'
import StartNewProjects from '@projects/components/StartNewProjects.vue'

const props = defineProps({
  components: {
    type: Object,
    default: () => ({}),
  },
  chartBlocks: {
    type: Array,
    default: () => ([]),
  },
  enableChartPresets: {
    type: Boolean,
    default: false,
  },
})

const { components, chartBlocks, enableChartPresets } = toRefs(props)
</script>

<style lang="scss" scoped>
.container {
  max-width: 900px;
}

.dashboard-grid {
  display: grid;
  grid-template-areas:
    "start-new-projects"
    "outstanding-actions"
    "chart-block";
  grid-gap: 1.5rem;
  margin-top: 1rem;

  > div:nth-child(1) { grid-area: outstanding-actions }
  > div:nth-child(2) { grid-area: start-new-projects }
  > div:nth-child(3) { grid-area: chart-block }

  > .card > .list-group {
    max-height: 30vh;
  }

  @media (min-width: 992px) {
    grid-template-areas:
      "start-new-projects"
      "outstanding-actions"
      "chart-block";
    grid-template-columns: 1fr;
    grid-gap: 2.25rem;
    margin-top: 1.5rem;
  }

  @media (min-width: 1200px) {
    grid-template-areas:
      "outstanding-actions start-new-projects"
      "chart-block chart-block";
    grid-template-columns: 1fr 1fr;
    grid-gap: 3rem;
    margin-top: 2rem;
  }
}
</style>
